import { useSuspenseQuery } from '@apollo/client/react';

import { findOneCourseQuery } from '~/shared/graphql-queries/courses';

const getFindOneCourseQuery = ({ alias }: { alias: string }) => ({
  query: findOneCourseQuery,
  variables: { alias },
  notifyOnNetworkStatusChange: true,
});

export const useFindOneCourseQuery = ({ alias, isFreeCourse }: { alias: string }) => {
  const useQueryProps = useSuspenseQuery(findOneCourseQuery, {
    variables: { alias, ...(isFreeCourse && { isFreeCourse: true }) },
    notifyOnNetworkStatusChange: true,
  });
  const { loading, error, data } = useQueryProps;

  return {
    loading,
    error,
    data,
  };
};
